import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const listBookmarks = gql`
  query ListBookmarksQuery {
    listBookmarks {
      bookmarks {
        ...BookmarkListItem
      }
    }
  }

  ${Fragments.bookmark.bookmark}
`;
